import { Component, inject, ViewEncapsulation } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TokenService } from '@services/token-service';
import { I18nPlaceholderDirective } from '../../directives/i18n.directives';
import { IconDirective } from '../../directives/icon.directive';
import { CopyrightComponent } from '../copyright/copyright.component';

@Component({
  selector: 'lv-forgot-password',
  templateUrl: 'forgot-password.component.html',
  styleUrls: ['forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [FormsModule, I18nPlaceholderDirective, IconDirective, TranslateModule, CopyrightComponent, RouterModule]
})
export class ForgotPasswordComponent {
  private tokenService = inject(TokenService);
  private router = inject(Router);

  email = '';
  loading = false;

  requestReset() {
    if (!this.email) {
      return;
    }

    this.loading = true;

    this.tokenService.resetPassword({ email: this.email }).subscribe({
      next: () => {
        this.router.navigate(['/auth/password/request-sent']);
      },
      error: () => {
        this.router.navigate(['/auth/password/request-sent']);
      }
    });
  }
}
